<template>
  <div>
    <h1>Privacy policy</h1>
    <p>
      At Unmatched Maker, accessible from https://unmatched.cards, one of our
      main priorities is the privacy of our visitors. This Privacy Policy
      document contains types of information that is collected and recorded by
      Unmatched Maker and how we use it.
    </p>

    <p>
      If you have additional questions or require more information about our
      Privacy Policy, do not hesitate to contact us.
    </p>

    <h2>Log Files</h2>

    <p>
      Unmatched Maker follows a standard procedure of using log files. These
      files log visitors when they visit websites. All hosting companies do this
      and a part of hosting services' analytics. The information collected by
      log files include internet protocol (IP) addresses, browser type, Internet
      Service Provider (ISP), date and time stamp, referring/exit pages, and
      possibly the number of clicks. These are not linked to any information
      that is personally identifiable. The purpose of the information is for
      analyzing trends, administering the site, tracking users' movement on the
      website, and gathering demographic information. Our Privacy Policy was
      created with the help of the
      <a href="https://www.privacypolicyonline.com/privacy-policy-generator/"
        >Privacy Policy Generator</a
      >
      and the
      <a href="https://www.generateprivacypolicy.com"
        >Privacy Policy Generator</a
      >.
    </p>

    <h2>Cookies and Web Beacons</h2>

    <p>
      Like many other websites, Unmatched Maker uses 'cookies'. These cookies
      are used to store information including visitors' preferences, and the
      pages on the website that the visitor accessed or visited. The information
      is used to optimize the users' experience by customizing our web page
      content based on visitors' browser type and/or other information.
    </p>

    <p>
      For more general information on cookies, please read the "What Are
      Cookies" article on
      <a href="https://www.cookieconsent.com/what-are-cookies/"
        >Cookie Consent website</a
      >.
    </p>

    <p>
      You can choose to disable cookies through your individual browser options.
      To know more detailed information about cookie management with specific
      web browsers, it can be found at the browsers' respective websites. What
      Are Cookies?
    </p>

    <h2>Children's Information</h2>

    <p>
      Another part of our priority is adding protection for children while using
      the internet. We encourage parents and guardians to observe, participate
      in, and/or monitor and guide their online activity.
    </p>

    <p>
      Unmatched Maker does not knowingly collect any Personal Identifiable
      Information from children under the age of 13. If you think that your
      child provided this kind of information on our website, we strongly
      encourage you to contact us immediately and we will do our best efforts to
      promptly remove such information from our records.
    </p>

    <h2>Online Privacy Policy Only</h2>

    <p>
      This Privacy Policy applies only to our online activities and is valid for
      visitors to our website with regards to the information that they shared
      and/or collect in Unmatched Maker. This policy is not applicable to any
      information collected offline or via channels other than this website.
    </p>

    <h2>Consent</h2>

    <p>
      By using our website, you hereby consent to our Privacy Policy and agree
      to its Terms and Conditions.
    </p>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  metaInfo: {
    title: "Privacy policy"
  }
};
</script>
